module.exports = __webpack_public_path__ + "static/media/burger-white.c2924f15.svg";